import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { PageTitle } from './commons'

export const AccessControlNoRights = ({ title, description }) => {
  const { t } = useTranslation()
  return (
    <div>
      <PageTitle title={title ? title : t('common.access_control.no_rights.title')} />
      <p>{description ? description : t('common.access_control.no_rights.description')}</p>
    </div>
  )
}

AccessControlNoRights.displayName = 'AccessControlNoRights'

AccessControlNoRights.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}

AccessControlNoRights.defaultProps = {
  title: null,
  description: null
}
